import React from 'react';
import { SEO } from '../components/SEO';
export function AboutPage() {
  return <>
      <SEO title="About Aspect" description="Aspect is the rights and verification infrastructure for real-world architectural imagery." data-id="element-79" />
      <div className="space-y-24 md:space-y-32" data-id="element-80">
        {/* Intro */}
        <section className="max-w-2xl" data-id="element-81">
          <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-8 text-aspect-black" data-id="element-82">
            About Aspect
          </h1>
        </section>

        {/* What Aspect Exists to Do */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-83">
          <div className="md:col-span-4" data-id="element-84">
            <span className="text-aspect-gray" data-id="element-85">Purpose</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-86">
            <h2 className="text-2xl font-medium" data-id="element-87">What Aspect Exists to Do</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-88">
              <p data-id="element-89">
                Aspect exists to make images of the built world usable as
                verified data.
              </p>
            </div>
          </div>
        </section>

        {/* System-First Philosophy */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-90">
          <div className="md:col-span-4" data-id="element-91">
            <span className="text-aspect-gray" data-id="element-92">Philosophy</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-93">
            <h2 className="text-2xl font-medium" data-id="element-94">System-First Philosophy</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-95">
              <p data-id="element-96">
                Aspect prioritizes correctness over expression and durability
                over speed.
              </p>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12 pb-12" data-id="element-97">
          <div className="md:col-span-4" data-id="element-98">
            <span className="text-aspect-gray" data-id="element-99">Team</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-100">
            <h2 className="text-2xl font-medium" data-id="element-101">Team</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-102">
              <p data-id="element-103">
                Aspect is built by operators with experience across
                architecture, technology, and rights-managed systems.
              </p>
            </div>
          </div>
        </section>
      </div>
    </>;
}